import React from "react";
import {observer} from "mobx-react";
import {Button} from "@mui/material";
import styled from "@emotion/styled";
import {useViewController} from "data/services/locator";
import {ILocalizationController} from "views/controllers/localization/localization.controller";
import {Bindings} from "data/constants/bindings";
import {IS_PROD} from "data/constants";

const ButtonElement = styled(Button)`
	position: fixed;
	left: 0;
	top: 0;
	z-index: 1210;
	width: 80px;
	height: 80px;
`;

export const LocalizationButton: React.FC = observer(() => {
	const {enableSkipTranslation} = useViewController<ILocalizationController>(
		Bindings.LocalizationController
	);
	if (IS_PROD) {
		return null;
	}

	return <ButtonElement onClick={enableSkipTranslation} tabIndex={-1} />;
});
